import { render, staticRenderFns } from "./landing-hermosillo.vue?vue&type=template&id=7d6eb534&scoped=true&"
import script from "./landing-hermosillo.vue?vue&type=script&lang=js&"
export * from "./landing-hermosillo.vue?vue&type=script&lang=js&"
import style0 from "./landing-hermosillo.vue?vue&type=style&index=0&id=7d6eb534&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6eb534",
  null
  
)

export default component.exports